import { URLENUM } from '@/enum-js/urlMap.js';
import { getStorageSync } from '@/utils/storage.js';
import { mobileProductDetailPath } from '@/utils/link/mobileProductDetail';
import { mobileSpecialDetailPath } from '@/utils/link/mobileSpecialDetail';

const buildMappedUrl = (baseUrl, query, columnTitleName) => {
	const params = [];
	if (query) params.push(query);
	if (columnTitleName) params.push(`columnTitleName=${columnTitleName}`);
	if (!params.length) return baseUrl;
	return `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}${params.join('&')}`;
};

export const getChildSiteId = function (url) {
	const mutil = getStorageSync('getMutil');
	if (!Array.isArray(mutil) || !url) return undefined;
	return mutil.find(item => url.includes(item.linkUrl))?.companyId;
};

export const mateUrl = function (url, columnTitleName) {
	if (!url) return '';

	try {
		const baseOrigin = typeof window !== 'undefined' && window.location?.origin ? window.location.origin : 'http://localhost';
		const parsedUrl = new URL(url.trim(), baseOrigin);
		const pathSegments = parsedUrl.pathname.split('/').filter(Boolean);
		const lastPathSegment = pathSegments[pathSegments.length - 1];
		if (lastPathSegment === 'specialDetail') {
			const searchParams = new URLSearchParams(parsedUrl.search);
			const specialId = searchParams.get('id') || '';
			const specialPath = mobileSpecialDetailPath(specialId);
			if (!specialPath) return '';
			const keyWord = searchParams.get('keyWord') || searchParams.get('keyword') || '';
			return keyWord ? `${specialPath}?keyWord=${encodeURIComponent(keyWord)}` : specialPath;
		}
	} catch {
		// 非标准链接继续走后续映射逻辑
	}

	let tUrl = '';
	const companyId = getChildSiteId(url);
	for (let p in URLENUM) {
		if (url.includes(p)) {
			tUrl = p;
		}
	}
	if (tUrl) {
		let query = url.split('?')[1];
		const queryObj = Object.fromEntries(new URLSearchParams(query || ''));
		if (companyId) {
			if (query) {
				if (!query.includes('companyId=')) {
					query = query + `&companyId=${companyId}`;
				}
			} else {
				query = `companyId=${companyId}`;
			}
		}

		// 子站首页：统一映射到 /[companyId]
		if (tUrl === '/otherStoreIndex/storeOtherStore') {
			const targetCompanyId = queryObj.companyId || companyId || '';
			if (!targetCompanyId) return '';
			return `/${targetCompanyId}`;
		}

		// 商品详情：统一映射到 /[companyId]/products/[productId].html
		if (tUrl === '/goodsDetails' || tUrl === '/otherStoreIndex/storeGoodsDetails') {
			const productId = queryObj.productId || queryObj.productid || '';
			const targetCompanyId = queryObj.companyId || companyId || '';
			return mobileProductDetailPath(targetCompanyId, productId) || '';
		}

		// 专区详情：统一映射到主站 /special/{id}（兼容 ?id=550 与路径 /specialArea/550 两种格式）
		if (tUrl === '/specialArea' || tUrl === '/storeSpecialArea') {
			const specialId =
				queryObj.id || url.match(/\/(?:specialArea|storeSpecialArea)\/([^/?#]+)/i)?.[1] || '';
			return mobileSpecialDetailPath(specialId) || '';
		}

		return buildMappedUrl(URLENUM[tUrl], query, columnTitleName);
	} else {
		// 未命中映射但可识别子站时，尽量回到子站首页
		if (companyId) return `/${companyId}`;
		return '';
	}
};

export const jumpTo = function (url, columnTitleName) {
	if (!import.meta.client) return;

	const res = mateUrl(url, columnTitleName);
	if (!res) {
		if (url) {
			if (url.indexOf('/') !== 0) {
				const externalUrl = !url.includes('://') ? 'http://' + url : url;
				// 对于外部URL，添加延迟确保埋点完成
				setTimeout(() => {
					window.location.href = externalUrl;
				}, 300);
			} else {
				navigateTo(url);
			}
		}
		return;
	} else {
		let httpUrl = '';
		const href = window.location.href;
		if (url.includes('-uat.gyqxmall.com') && !href.includes('-uat.gyqxmall.com')) {
			httpUrl = 'https://m-uat-seo.gyqxmall.com';
		} else if (url.includes('beta.cmic.com.cn') && !href.includes('beta-m.cmic.com.cn')) {
			httpUrl = 'https://beta-m.cmic.com.cn';
		}
		if (httpUrl) {
			window.location.href = httpUrl + res;
		} else {
			navigateTo(res);
		}
	}
};

export const objectToQueryString = obj => {
	if (!obj || typeof obj !== 'object') return '';
	return Object.keys(obj)
		.map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key] ?? '')}`)
		.join('&');
};

export const queryStringToObject = queryString => {
	const queryStringStartIndex = queryString.indexOf('?');
	if (queryStringStartIndex === -1) {
		return {};
	}
	queryString = queryString.slice(queryStringStartIndex + 1);
	queryString = queryString.replace(/#$/, '');
	const pairs = queryString.split('&');
	const result = {};
	pairs.forEach(pair => {
		const [key, value] = pair.split('=');
		result[decodeURIComponent(key)] = decodeURIComponent(value || '');
	});
	return result;
};
